module.exports = __webpack_public_path__ + "static/media/sun-rain.fc41cebe.svg";